import { AttributeValue } from 'app/components/attributes/attributes.model';
import { Entity } from 'app/pages/product/product.model';


export class Preference {
    id: number;
    name: string;
    value: string;

    constructor(preference?) {
        preference = preference || {};

        this.id = preference.id;
        this.name = preference.name;
        this.value = preference.value;
    }
}

export class Permission
{
    id: number;
    name: string;
    action: string;
    category: string;
    categoryLabel: string;

    constructor(permission?)
    {
        permission = permission || {};

        this.id = permission.id;
        this.name = permission.name;
        this.action = permission.action;
        this.category = permission.category;
        this.categoryLabel = permission.categoryLabel;
    }
}


export class Role extends Entity
{
    
    description: string;
    creationDate: Date;
    permissions: Permission[];
    users: Entity[];
    hourIncome: number;
    externalId: string;
    allowedTemplates: string;
    

    /**
     * Constructor
     *
     * @param role
     */
    constructor(role?)
    {
        role = role || {};
        super(role);
        this.description = role.description || '';

        // this.createdBy= role.createdBy;
        this.creationDate = role.creationDate;
        this.permissions = role.permissions || [];
        this.users = role.users || [];
        this.hourIncome = role.hourIncome || 0;

    }

}
